module.exports = __webpack_public_path__ + "static/media/2805a44f849d578506544caae12f3297_html_5524891002f0d477.46211e09.png";